import dayjs, { Dayjs } from "dayjs";
import { RedemptionSort } from "../../../../../../models/Dashboard/Redemption/RedemptionFilters";

const EMPTY_VALUE = "—";

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

export const formatRedemptionCount = (
  value: number | null | undefined,
): string => {
  try {
    if (!isFiniteNumber(value)) {
      return EMPTY_VALUE;
    }
    return value.toLocaleString("en-IN");
  } catch (error) {
    return EMPTY_VALUE;
  }
};

export const formatRedemptionShare = (
  value: number | null | undefined,
): string => {
  try {
    if (!isFiniteNumber(value)) {
      return EMPTY_VALUE;
    }
    return `${Math.trunc(value)}%`;
  } catch (error) {
    return EMPTY_VALUE;
  }
};

export const formatRedemptionDateTime = (value: unknown): string => {
  try {
    if (value == null || value === "") {
      return EMPTY_VALUE;
    }
    if (typeof value === "number") {
      return formatRedemptionCount(value);
    }
    const raw = String(value);
    const parsed = dayjs(raw);
    if (!parsed.isValid()) {
      return raw;
    }
    return parsed.format("D MMM YYYY, HH:mm");
  } catch (error) {
    return EMPTY_VALUE;
  }
};

export const formatRedemptionStat = (
  value: number | string | null | undefined,
): string => {
  try {
    if (value == null || value === "") {
      return EMPTY_VALUE;
    }
    if (typeof value === "number") {
      return formatRedemptionCount(value);
    }
    return value;
  } catch (error) {
    return EMPTY_VALUE;
  }
};

export const formatRedemptionCell = (value: unknown): string => {
  try {
    if (value == null || value === "") {
      return EMPTY_VALUE;
    }
    if (typeof value === "number") {
      return formatRedemptionCount(value);
    }
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }
    return String(value);
  } catch (error) {
    return EMPTY_VALUE;
  }
};

export const formatTopVariant = (
  variant: string | null | undefined,
  units: number | null | undefined,
): string => {
  try {
    if (!variant) {
      return EMPTY_VALUE;
    }
    if (!isFiniteNumber(units)) {
      return variant;
    }
    return `${variant} · ${formatRedemptionCount(units)}`;
  } catch (error) {
    return variant || EMPTY_VALUE;
  }
};

export const redemptionRangeSlug = (start: Dayjs, end: Dayjs): string => {
  try {
    return `${start.format("YYYY-MM-DD")}_to_${end.format("YYYY-MM-DD")}`;
  } catch (error) {
    return "range";
  }
};

export const nextRedemptionSort = (
  current: RedemptionSort | null,
  column: string,
): RedemptionSort => {
  if (current?.column === column) {
    return { column, dir: current.dir === "desc" ? "asc" : "desc" };
  }
  return { column, dir: "desc" };
};
